import { FormattedMessage } from 'react-intl';

export function GlobalLoader() {
    return (
        <span data-testid="global-loader">
            <FormattedMessage id="global.loading" />
        </span>
    );
}
